(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-cross-sell"] && !Shopify.designMode) return;
  try {
    (function () {
    var hosts = document.querySelectorAll('[data-cross-sell-fetch]');
    if (!hosts.length) return;
    hosts.forEach(function (host) {
      var id = host.getAttribute('data-cross-sell');
      var url = host.getAttribute('data-url');
      if (!url) return;
      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cross-sell="' + id + '"]');
          // Only swap if the re-rendered block actually produced a rail of real products.
          if (fresh && !fresh.hasAttribute('data-cross-sell-fetch') && fresh.querySelector('.product-cross-sell__rail')) {
            host.removeAttribute('data-cross-sell-fetch');
            host.innerHTML = fresh.innerHTML;
          } else {
            host.remove();
          }
        })
        .catch(function () { host.remove(); });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    // Une seule initialisation par galerie, même si le fichier est évalué deux fois.
    function init(root) {
      if (root.dataset.galerieInit === '1') return;
      root.dataset.galerieInit = '1';

      var track = root.querySelector('[data-gallery-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
      var thumbsRail = root.querySelector('[data-gallery-thumbs]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-dot]'));
      var prev = root.querySelector('[data-gallery-prev]');
      var next = root.querySelector('[data-gallery-next]');
      var calme = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var doux = calme ? 'auto' : 'smooth';

      function indexCourant() {
        var milieu = track.scrollLeft + track.clientWidth / 2;
        var best = 0;
        var ecartMin = Infinity;
        slides.forEach(function (s, i) {
          var centre = s.offsetLeft - track.offsetLeft + s.offsetWidth / 2;
          var ecart = Math.abs(centre - milieu);
          if (ecart < ecartMin) { ecartMin = ecart; best = i; }
        });
        return best;
      }

      function allerA(i) {
        var s = slides[Math.max(0, Math.min(slides.length - 1, i))];
        if (!s) return;
        track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: doux });
      }

      // Le rail suit la diapositive courante : sans ça, la vignette active sort du cadre dès
      // la sixième image et le repère de position disparaît au moment où il sert.
      function suivre(i) {
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
        if (!thumbsRail) return;
        var actif = thumbsRail.querySelectorAll('li')[i];
        if (!actif) return;
        var vignette = actif.getBoundingClientRect();
        var cadre = thumbsRail.getBoundingClientRect();
        if (vignette.left < cadre.left || vignette.right > cadre.right) {
          thumbsRail.scrollTo({
            left: actif.offsetLeft - thumbsRail.offsetLeft - (thumbsRail.clientWidth - actif.offsetWidth) / 2,
            behavior: doux
          });
        }
      }

      var enAttente = false;
      track.addEventListener('scroll', function () {
        if (enAttente) return;
        enAttente = true;
        window.requestAnimationFrame(function () { enAttente = false; suivre(indexCourant()); });
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { allerA(indexCourant() - 1); });
      if (next) next.addEventListener('click', function () { allerA(indexCourant() + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { allerA(i); }); });

      // Le zoom : assets/product.js possède déjà le clic sur l'IMAGE. On n'ajoute que le clic
      // sur la loupe — cible différente, donc aucune double bascule possible — et l'origine du
      // grossissement, qui n'est qu'une lecture de coordonnées, jamais une bascule.
      root.addEventListener('pointerdown', function (e) {
        var img = e.target.closest ? e.target.closest('.product-gallery__image') : null;
        if (!img) return;
        var r = img.getBoundingClientRect();
        img.style.transformOrigin =
          ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
      root.addEventListener('click', function (e) {
        var loupe = e.target.closest ? e.target.closest('[data-gallery-zoom]') : null;
        if (!loupe) return;
        var slide = loupe.closest('[data-gallery-slide]');
        if (slide) slide.classList.toggle('is-zoomed');
      });

      // La vidéo. Trois choses, et la première est une règle d'accessibilité, pas un détail :
      // si l'utilisateur a demandé « moins de mouvement », rien ne démarre tout seul — on
      // retombe sur l'affiche et le bouton de lecture devient le seul chemin.
      root.querySelectorAll('[data-gallery-video]').forEach(function (v) {
        var cmd = v.parentElement.querySelector('.product-gallery__vcmd');
        var bPlay = cmd && cmd.querySelector('[data-gallery-video-play]');
        var bSon = cmd && cmd.querySelector('[data-gallery-video-sound]');
        if (calme) {
          v.autoplay = false;
          v.removeAttribute('autoplay');
          try { v.pause(); } catch (err) { /* rien à faire : la vidéo n'a pas démarré */ }
        }
        function etat() { if (bPlay) bPlay.setAttribute('aria-pressed', String(!v.paused)); }
        v.addEventListener('play', etat);
        v.addEventListener('pause', etat);
        etat();
        if (bPlay) bPlay.addEventListener('click', function () { if (v.paused) v.play(); else v.pause(); });
        if (bSon) bSon.addEventListener('click', function () {
          v.muted = !v.muted;
          bSon.setAttribute('aria-pressed', String(!v.muted));
        });
      });

      // Le clavier : les flèches déplacent la piste, sinon un scroller n'a pas de commande.
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); allerA(indexCourant() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); allerA(indexCourant() - 1); }
      });

      suivre(0);
    }

    function tout() { document.querySelectorAll('[data-catharsis-galerie]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
    else tout();
    document.addEventListener('shopify:section:load', tout);
    document.addEventListener('shopify:block:select', tout);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-quantity-breaks"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-pdp-column] .product-tiers') || document.querySelector('.product-tiers');
    if (!root) return;
    var btns = root.querySelectorAll('[data-tier-qty]');
    if (!btns.length) return;

    // Le champ quantité du formulaire d'achat est la source de vérité : le palier ne fait que
    // l'écrire. Rien n'est stocké en double, donc rien ne peut se désynchroniser.
    function qtyInput() {
      return document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    }

    function sync(q) {
      btns.forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-tier-qty')) === Number(q)));
      });
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var q = b.getAttribute('data-tier-qty');
        var input = qtyInput();
        if (input) {
          input.value = q;
          // `change` réveille tout ce qui écoute le champ (prix affiché, boutons d'achat) ;
          // écrire `.value` seul ne déclenche rien.
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sync(q);
      });
    });

    var input = qtyInput();
    if (input) {
      sync(input.value);
      input.addEventListener('change', function () { sync(input.value); });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
